import { connect }          from 'react-redux';
import Errors               from '../../../errors';
import { fetchCatalogUrl }  from '../../../catalog-dux';
import { dismissAllErrors } from '../../../errors-dux';

import Home from './home.jsx';

export function getMediaLabel( labels, locale, defaultLocale ) {
    let mediaLabel;

    if ( labels && labels.length === 1 ) {
        mediaLabel = labels[ 0 ].cmText;
    } else {
        mediaLabel = labels && ( labels.find(
            mediaLabel =>
                ( locale && locale.code === mediaLabel.locale.code || defaultLocale.code === mediaLabel.locale.code || 'en-US' === mediaLabel.locale.code )
            ) ).cmText;
    }
    return mediaLabel;
}

export default connect(
    // mapStateToProps
    state => {
        const mediaLabels = state.clientData.clientBranding.mediaLabels;
        const user = state.userData;
        const mediaLabel = getMediaLabel( mediaLabels, state.userData.locale, state.clientData.locale );
        const busyFetchingCatalogUrl = state.catalogData.busyFetchingCatalogUrl;
        const catalogUrlErrors = Errors.getByType( state, Errors.ERROR_SHOP_FETCH_CATALOG_URL );

        return {
            user,
            mediaLabel,
            busyFetchingCatalogUrl,
            catalogUrlErrors
        };
    },
    // mapDispatchToProps
    {
        fetchCatalogUrl,
        dismissAllErrors
    }
)( Home );
